import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './errorboundary'

const ForgotPasswordPage = lazy(() => import('./forgotPassword'))

const ForgotPasswordViewContainer = () => (
    <div>
        <Suspense fallback={<Spinner />}>
            <ErrorBoundary>
                <ForgotPasswordPage />
            </ErrorBoundary>
        </Suspense>
    </div>
)

export default ForgotPasswordViewContainer
